<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex sm6 xs12 md4 lg4>
        <material-stats-card
          to="/adverse_events"
          color="primary"
          icon="mdi-account-alert"
          title="Adverse Events"
          :value="''+dashboardData.adverse_event"
          sub-icon="mdi-view-list"
          sub-text="Go to list..."
        />
      </v-flex>

      <v-flex sm6 xs12 md4 lg4>
        <material-stats-card 
          to="/pregnancies"
          color="orange"
          icon="mdi-human-pregnant"
          title="Pregnancy"
          :value="''+dashboardData.pregnancy"
          sub-icon="mdi-view-list"
          sub-text="Go to List..." />
      </v-flex>

      <v-flex sm6 xs12 md4 lg4>
        <material-stats-card 
          to="/spms"
          color="brown"
          icon="mdi-numeric-2-box-multiple-outline"
          title="SPM"
          :value="''+dashboardData.spm"
          sub-icon="mdi-view-list"
          sub-text="Go to List..." />
      </v-flex>
      

      <v-flex md12 lg12  v-if="!isMM">
        <material-card
          color="primary"
          title="Adverse Events (UNREAD)"
          text=""
          class="elevation-1">
          

           <v-tooltip top close-delay='200' min-width='50px'>
            <template slot="activator" slot-scope="{ on }">
               <v-btn
                  v-on="on"
                  v-if="$can('import', 'adverse_event' )"
                  color="pink"
                  style="margin-right:110px"
                  dark
                  small
                  absolute
                  top
                  right
                  @click="pickFile()"
                >
                  <v-icon>mdi-upload-multiple</v-icon>
                </v-btn>
              </template>
              <span>Update multiple SAE</span>
          </v-tooltip>

          <v-btn
            v-if="$can('upsert', 'adverse_event' )"
            color="pink"
            style="margin-right:10px"
            dark
            small
            absolute
            top
            right
            @click="addAdverseEvent()"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <v-data-table
            id="adverseEvents_dataTable"
            :headers="headersAdverseEvents"
            :items="adverse_events"
            :pagination.sync="paginationAdverseEvents"
            :rows-per-page-items="[2, 5,10,20]"
            :total-items="totalAdverseEvents"
            :loading="loading"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            sort-icon="mdi-menu-down"
            class="dataTable"
          >
            <v-progress-linear
              v-slot:progress
              color="green"
              indeterminate
            ></v-progress-linear>

            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column',
                    header.align ?'text-xs-' + header.align : 'text-xs-left',
                    paginationAdverseEvents.descending ? 'desc' : 'asc',
                    header.sortable != false ? 'sortable' : '',
                    header.value === paginationAdverseEvents.sortBy ? 'active' : ''
                  ]"
                  @click="
                    if (header.sortable != false) {
                      changeSort(header.value);
                    }
                  "
                >
                  <v-icon v-if="header.sortable != false" small
                    >mdi-menu-down</v-icon
                  >
                  <span
                    class="subheading font-weight-dark text-success text-darken-3"
                    v-text="header.text"
                  ></span>
                </th>
              </tr>
            <tr class=" lighten-3">
                <th v-for="header in props.headers" :key="header.text">
                  <div  style="max-width:200px">
                    <v-select v-if="props.headers[0]==header"
                       v-model="protocolAdverseEventSelected"
                       clearable
                      :items="protocolListAdverseEvents" item-text="name"
                      item-value="id" placeholder="Select Protocol"
                      class="purple-input truncate" @change="filterChanged(protocolAdverseEventSelected)"></v-select>
                  </div>
                </th>
            </tr>
            </template>

            <template slot="items" slot-scope="{ item }">
              <tr :class="item.is_read ? 'read' :  'unread'">
                <td>{{ item.protocol.name }}</td>
                <td class="text-xs-left" >
                     
                  <v-tooltip top>
                    <template slot="activator" slot-scope="{ on }">
                         <span v-on="on" >{{ item.cin || '-----' }}</span>
                      </template>
                      <span>{{ item.case_type }}</span>
                  </v-tooltip>

                 
                </td>
                <td class="text-xs-left">
                  
                  <v-tooltip top min-width='100px'>
                    <template slot="activator" slot-scope="{ on }">
                        <div v-on="on" >
                          <!-- //issue 257 services -->
                          {{ formatDate(item.receipt_date) }}
                          <!-- //issue 257 services -->
                        </div>
                      </template>
                      <span>On Set Date {{ item.ae_onset_date }}</span>
                  </v-tooltip>

                </td>
                <td class="text-xs-left">{{ item.patient_id }}</td>
                <td class="text-xs-left">
                  <v-tooltip top min-width='500px'>
                    <template slot="activator" slot-scope="{ on }">
                        <div v-on="on" >
                          {{ item.protocol_has_site && item.protocol_has_site.code ? item.protocol_has_site.code : '---'}}
                        </div>
                      </template>
                      <span>{{item.site.name}} ({{item.site.country}}) - [{{item.site.code}}]</span>
                  </v-tooltip>
                </td>
                <td class="text-xs-left">
                  
                  <v-tooltip top min-width='500px' :disabled="item.ae_verbatim_reported.length <= 25">
                    <template slot="activator" slot-scope="{ on }">
                         <span v-on="on" >{{ item.ae_verbatim_reported | truncate(25, '...') }}</span>
                      </template>
                      <span>{{ item.ae_verbatim_reported }}</span>
                  </v-tooltip>
                  
                </td>
                <td class="text-xs-left">{{ item.case_assessment }}</td>
                <td class="text-xs-left">
                   <v-tooltip top min-width='500px'>
                    <template slot="activator" slot-scope="{ on }">
                         <v-icon v-on="on" v-if="item.sponsor_triage" color="green">mdi-check</v-icon>
                      </template>
                      <span>{{item.sponsor_triage}}</span>
                  </v-tooltip>
                </td>
                <td class="text-xs-left">

                  <v-tooltip top min-width='100px' :disabled="!item.errors">
                    <template slot="activator" slot-scope="{ on }">
                        <div v-on="on" >
                          {{ item.status }}
                        </div>
                      </template>
                      <span>{{ item.errors }}</span>
                  </v-tooltip>

                </td>
               
               
                <!--td class="text-xs-left"><v-icon v-if="item.crf" color="green">mdi-check</v-icon></td-->


                <td class="text-xs-left">
                  <v-icon v-if="item.company_notification_date" color="green">mdi-check</v-icon>
                  <v-icon v-if="item.medical_notification_date" color="green">mdi-check</v-icon>
                </td>

                <td class="text-xs-center">
                  <v-tooltip top>
                    <template slot="activator" slot-scope="{ on }">
                      <a flat @click="upsertPage(item)">
                        <v-icon v-if="$can('upsert', 'adverse_event')" v-on="on" color="primary">mdi-pencil</v-icon>
                        <v-icon v-if="!$can('upsert', 'adverse_event')" v-on="on" color="primary">mdi-eye</v-icon>
                      </a>
                    </template>
                    <span>Edit Adverse Event</span>
                  </v-tooltip>

                </td>
              </tr>
            </template>


          </v-data-table>

        </material-card>
      </v-flex>


      <v-flex md12 lg12 v-if="!isMM && !isGuest">
        <material-card
          color="primary"
          title="Medical Monitor Updated"
          text=""
          class="elevation-1">
          

          <v-data-table
            id="mm_adverseEvents_dataTable"
            :headers="headersAdverseEvents"
            :items="medical_monitor_adverse_events"
            :pagination.sync="paginationMedicalMonitor"
            :rows-per-page-items="[2, 5,10,20]"
            :total-items="totalMedicalMonitorAdverseEvents"
            :loading="loading"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            sort-icon="mdi-menu-down"
            class="dataTable"
          >
            <v-progress-linear
              v-slot:progress
              color="green"
              indeterminate
            ></v-progress-linear>

            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column',
                    header.align ?'text-xs-' + header.align : 'text-xs-left',
                    paginationAdverseEvents.descending ? 'desc' : 'asc',
                    header.sortable != false ? 'sortable' : '',
                    header.value === paginationAdverseEvents.sortBy ? 'active' : ''
                  ]"
                  @click="
                    if (header.sortable != false) {
                      changeSort(header.value);
                    }
                  ">
                  <v-icon v-if="header.sortable != false" small
                    >mdi-menu-down</v-icon>
                  <span
                    class="subheading font-weight-dark text-success text-darken-3"
                    v-text="header.text"
                  ></span>
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="{ item }">
              <tr :class="item.is_read ? 'read' :  'unread'">

                <td>{{ item.protocol.name }}</td>

                <td class="text-xs-left" >
                  <v-tooltip top>
                    <template slot="activator" slot-scope="{ on }">
                         <span v-on="on" >{{ item.cin || '-----' }}</span>
                      </template>
                      <span>{{ item.case_type }}</span>
                  </v-tooltip>
                </td>

                <td class="text-xs-left">
                  <v-tooltip top min-width='100px'>
                    <template slot="activator" slot-scope="{ on }">
                        <div v-on="on" >
                          <!-- //issue 257 services -->
                          {{ formatDate(item.receipt_date) }}
                          <!-- //issue 257 services -->
                        </div>
                      </template>
                      <span>On Set Date {{ item.ae_onset_date }}</span>
                  </v-tooltip>
                </td>
                
                <td class="text-xs-left">{{ item.patient_id }}</td>
                
                <td class="text-xs-left">
                  <v-tooltip top min-width='500px'>
                    <template slot="activator" slot-scope="{ on }">
                        <div v-on="on" >
                          {{ item.protocol_has_site && item.protocol_has_site.code ? item.protocol_has_site.code : '---'}}
                        </div>
                      </template>
                      <span>{{item.site.name}} ({{item.site.country}}) - [{{item.site.code}}]</span>
                  </v-tooltip>
                </td>

                <td class="text-xs-left">
                  <v-tooltip top min-width='500px' :disabled="item.ae_verbatim_reported.length <= 25">
                    <template slot="activator" slot-scope="{ on }">
                         <span v-on="on" >{{ item.ae_verbatim_reported | truncate(25, '...') }}</span>
                      </template>
                      <span>{{ item.ae_verbatim_reported }}</span>
                  </v-tooltip>
                </td>

                <td class="text-xs-left">{{ item.case_assessment }}</td>

                <td class="text-xs-left">
                   <v-tooltip top min-width='500px'>
                    <template slot="activator" slot-scope="{ on }">
                         <v-icon v-on="on" v-if="item.sponsor_triage" color="green">mdi-check</v-icon>
                      </template>
                      <span>{{item.sponsor_triage}}</span>
                  </v-tooltip>
                </td>
                <td class="text-xs-left">
                  <v-tooltip top min-width='100px' :disabled="!item.errors">
                    <template slot="activator" slot-scope="{ on }">
                        <div v-on="on" >
                          {{ item.status }}
                        </div>
                      </template>
                      <span>{{ item.errors }}</span>
                  </v-tooltip>
                </td>
               
                <td class="text-xs-left">
                  <v-icon v-if="item.company_notification_date" color="green">mdi-check</v-icon>
                  <v-icon v-if="item.medical_notification_date" color="green">mdi-check</v-icon>
                </td>

                <td class="text-xs-center">
                  <v-tooltip top>
                    <template slot="activator" slot-scope="{ on }">
                      <a flat @click="upsertPage(item)">
                        <v-icon v-if="$can('upsert', 'adverse_event')" v-on="on" color="primary">mdi-pencil</v-icon>
                        <v-icon v-if="!$can('upsert', 'adverse_event')" v-on="on" color="primary">mdi-eye</v-icon>
                      </a>
                    </template>
                    <span>Edit Adverse Event</span>
                  </v-tooltip>

                </td>
              </tr>
            </template>


          </v-data-table>
          
        </material-card>
      </v-flex>


      <v-flex md12 lg12 v-if="isMM">
        <material-card
          color="primary"
          title="Medical Monitor Query Updated"
          text=""
          class="elevation-1">
          

          <v-data-table
            id="mm_query_adverseEvents_dataTable"
            :headers="headersAdverseEvents"
            :items="medical_monitor_query_adverse_events"
            :pagination.sync="paginationMedicalMonitorQuery"
            :rows-per-page-items="[2, 5,10,20]"
            :total-items="totalMedicalMonitorQueryAdverseEvents"
            :loading="loading"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            sort-icon="mdi-menu-down"
            class="dataTable"
          >
            <v-progress-linear
              v-slot:progress
              color="green"
              indeterminate
            ></v-progress-linear>

            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column',
                    header.align ?'text-xs-' + header.align : 'text-xs-left',
                    paginationAdverseEvents.descending ? 'desc' : 'asc',
                    header.sortable != false ? 'sortable' : '',
                    header.value === paginationAdverseEvents.sortBy ? 'active' : ''
                  ]"
                  @click="
                    if (header.sortable != false) {
                      changeSort(header.value);
                    }
                  ">
                  <v-icon v-if="header.sortable != false" small
                    >mdi-menu-down</v-icon>
                  <span
                    class="subheading font-weight-dark text-success text-darken-3"
                    v-text="header.text"
                  ></span>
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="{ item }">
              <tr :class="item.is_read ? 'read' :  'unread'">

                <td>{{ item.protocol.name }}</td>

                <td class="text-xs-left" >
                  <v-tooltip top>
                    <template slot="activator" slot-scope="{ on }">
                         <span v-on="on" >{{ item.cin || '-----' }}</span>
                      </template>
                      <span>{{ item.case_type }}</span>
                  </v-tooltip>
                </td>

                <td class="text-xs-left">
                  <v-tooltip top min-width='100px'>
                    <template slot="activator" slot-scope="{ on }">
                        <div v-on="on" >
                          {{ item.receipt_date }}
                        </div>
                      </template>
                      <span>On Set Date {{ item.ae_onset_date }}</span>
                  </v-tooltip>
                </td>
                
                <td class="text-xs-left">{{ item.patient_id }}</td>
                
                <td class="text-xs-left">
                  <v-tooltip top min-width='500px'>
                    <template slot="activator" slot-scope="{ on }">
                        <div v-on="on" >
                          {{ item.protocol_has_site && item.protocol_has_site.code ? item.protocol_has_site.code : '---'}}
                        </div>
                      </template>
                      <span>{{item.site.name}} ({{item.site.country}}) - [{{item.site.code}}]</span>
                  </v-tooltip>
                </td>

                <td class="text-xs-left">
                  <v-tooltip top min-width='500px' :disabled="item.ae_verbatim_reported.length <= 25">
                    <template slot="activator" slot-scope="{ on }">
                         <span v-on="on" >{{ item.ae_verbatim_reported | truncate(25, '...') }}</span>
                      </template>
                      <span>{{ item.ae_verbatim_reported }}</span>
                  </v-tooltip>
                </td>

                <td class="text-xs-left">{{ item.case_assessment }}</td>

                <td class="text-xs-left">
                   <v-tooltip top min-width='500px'>
                    <template slot="activator" slot-scope="{ on }">
                         <v-icon v-on="on" v-if="item.sponsor_triage" color="green">mdi-check</v-icon>
                      </template>
                      <span>{{item.sponsor_triage}}</span>
                  </v-tooltip>
                </td>
                <td class="text-xs-left">
                  <v-tooltip top min-width='100px' :disabled="!item.errors">
                    <template slot="activator" slot-scope="{ on }">
                        <div v-on="on" >
                          {{ item.status }}
                        </div>
                      </template>
                      <span>{{ item.errors }}</span>
                  </v-tooltip>
                </td>
               
                <td class="text-xs-left">
                  <v-icon v-if="item.company_notification_date" color="green">mdi-check</v-icon>
                  <v-icon v-if="item.medical_notification_date" color="green">mdi-check</v-icon>
                </td>

                <td class="text-xs-center">
                  <v-tooltip top>
                    <template slot="activator" slot-scope="{ on }">
                      <a flat @click="upsertPage(item)">
                        <v-icon v-if="$can('upsert', 'adverse_event')" v-on="on" color="primary">mdi-pencil</v-icon>
                        <v-icon v-if="!$can('upsert', 'adverse_event')" v-on="on" color="primary">mdi-eye</v-icon>
                      </a>
                    </template>
                    <span>Edit Adverse Event</span>
                  </v-tooltip>

                </td>
              </tr>
            </template>


          </v-data-table>
          
        </material-card>
      </v-flex>

      <v-flex md12 lg12 v-if="isMM">
        <material-card
          color="primary"
          title="Medical Monitor Notified"
          text=""
          class="elevation-1">

          <v-data-table
            id="mm_query_notified_dataTable"
            :headers="headersAdverseEvents"
            :items="medical_monitor_notified"
            :pagination.sync="paginationMedicalMonitorNotified"
            :rows-per-page-items="[2, 5,10,20]"
            :total-items="totalMedicalMonitorNotified"
            :loading="loading"
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            sort-icon="mdi-menu-down"
            class="dataTable"
          >
            <v-progress-linear
              v-slot:progress
              color="green"
              indeterminate
            ></v-progress-linear>

            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column',
                    header.align ?'text-xs-' + header.align : 'text-xs-left',
                    paginationAdverseEvents.descending ? 'desc' : 'asc',
                    header.sortable != false ? 'sortable' : '',
                    header.value === paginationAdverseEvents.sortBy ? 'active' : ''
                  ]"
                  @click="
                    if (header.sortable != false) {
                      changeSort(header.value);
                    }
                  ">
                  <v-icon v-if="header.sortable != false" small
                    >mdi-menu-down</v-icon>
                  <span
                    class="subheading font-weight-dark text-success text-darken-3"
                    v-text="header.text"
                  ></span>
                </th>
              </tr>
            </template>

            <template slot="items" slot-scope="{ item }">
              <tr :class="item.is_read ? 'read' :  'unread'">

                <td>{{ item.protocol.name }}</td>

                <td class="text-xs-left" >
                  <v-tooltip top>
                    <template slot="activator" slot-scope="{ on }">
                         <span v-on="on" >{{ item.cin || '-----' }}</span>
                      </template>
                      <span>{{ item.case_type }}</span>
                  </v-tooltip>
                </td>

                <td class="text-xs-left">
                  <v-tooltip top min-width='100px'>
                    <template slot="activator" slot-scope="{ on }">
                        <div v-on="on" >
                          {{ item.receipt_date }}
                        </div>
                      </template>
                      <span>On Set Date {{ item.ae_onset_date }}</span>
                  </v-tooltip>
                </td>
                
                <td class="text-xs-left">{{ item.patient_id }}</td>
                
                <td class="text-xs-left">
                  <v-tooltip top min-width='500px'>
                    <template slot="activator" slot-scope="{ on }">
                        <div v-on="on" >
                          {{ item.protocol_has_site && item.protocol_has_site.code ? item.protocol_has_site.code : '---'}}
                        </div>
                      </template>
                      <span>{{item.site.name}} ({{item.site.country}}) - [{{item.site.code}}]</span>
                  </v-tooltip>
                </td>

                <td class="text-xs-left">
                  <v-tooltip top min-width='500px' :disabled="item.ae_verbatim_reported.length <= 25">
                    <template slot="activator" slot-scope="{ on }">
                         <span v-on="on" >{{ item.ae_verbatim_reported | truncate(25, '...') }}</span>
                      </template>
                      <span>{{ item.ae_verbatim_reported }}</span>
                  </v-tooltip>
                </td>

                <td class="text-xs-left">{{ item.case_assessment }}</td>

                <td class="text-xs-left">
                   <v-tooltip top min-width='500px'>
                    <template slot="activator" slot-scope="{ on }">
                         <v-icon v-on="on" v-if="item.sponsor_triage" color="green">mdi-check</v-icon>
                      </template>
                      <span>{{item.sponsor_triage}}</span>
                  </v-tooltip>
                </td>
                <td class="text-xs-left">
                  <v-tooltip top min-width='100px' :disabled="!item.errors">
                    <template slot="activator" slot-scope="{ on }">
                        <div v-on="on" >
                          {{ item.status }}
                        </div>
                      </template>
                      <span>{{ item.errors }}</span>
                  </v-tooltip>
                </td>
               
                <td class="text-xs-left">
                  <v-icon v-if="item.company_notification_date" color="green">mdi-check</v-icon>
                  <v-icon v-if="item.medical_notification_date" color="green">mdi-check</v-icon>
                </td>

                <td class="text-xs-center">
                  <v-tooltip top>
                    <template slot="activator" slot-scope="{ on }">
                      <a flat @click="upsertPage(item)">
                        <v-icon v-if="$can('upsert', 'adverse_event')" v-on="on" color="primary">mdi-pencil</v-icon>
                        <v-icon v-if="!$can('upsert', 'adverse_event')" v-on="on" color="primary">mdi-eye</v-icon>
                      </a>
                    </template>
                    <span>Edit Adverse Event</span>
                  </v-tooltip>

                </td>
              </tr>
            </template>


          </v-data-table>
          
        </material-card>
      </v-flex>


      <v-flex md12 lg12 v-if="$can('read', 'log' || 'all' )">
        <material-card color="secondary" title="Audit Trail">
          <v-data-table
            :loading="loadingLogs"
            loading-text="Loading logs...."
            :headers="headersLogs"
            :items="logs"
            :total-items="totalLogs"
            :pagination.sync="paginationLogs"
            :rows-per-page-items="[5,10,20]"
            class="dataTable"
            item-key="insert_at">
           
            <!--
            <template v-slot:loading>
              <v-skeleton-loader type="table-row@10"></v-skeleton-loader>
            </template>
            -->
            
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column',
                    header.align ?'text-xs-' + header.align : 'text-xs-left',
                    paginationAdverseEvents.descending ? 'desc' : 'asc',
                    header.sortable != false ? 'sortable' : '',
                    header.value === paginationAdverseEvents.sortBy ? 'active' : ''
                  ]"
                  @click="
                    if (header.sortable != false) {
                      changeSort(header.value);
                    }
                  "
                >
                  <v-icon v-if="header.sortable != false" small
                    >mdi-menu-down</v-icon
                  >
                  <span
                    class="subheading font-weight-dark text-success text-darken-3"
                    v-text="header.text"
                  ></span>
                </th>
              </tr>
              
              <tr class=" lighten-3">
                <th v-for="header in props.headers" :key="header.text">
                  <div v-if="filtersLogs.hasOwnProperty(header.value)">
                    <v-text-field
                      clearable
                      md4
                      v-if="filtersLogs[header.value].type == 'text'"
                      v-model="filtersLogs[header.value].value"
                      :placeholder="filtersLogs[header.value].placeholder"
                    />

                    <v-select
                      clearable
                      md4
                      v-if="filtersLogs[header.value].type == 'list'"
                      v-model="filtersLogs[header.value].value"
                      :items="filtersLogs[header.value].list"
                      :placeholder="filtersLogs[header.value].placeholder"
                      class="purple-input"
                    ></v-select>

                    <v-autocomplete
                      clearable
                      md4
                      v-if="filtersLogs[header.value].type == 'autocomplete'"
                      v-model="filtersLogs[header.value].value"
                      :items="filtersLogs[header.value].list"
                      :item-value="filtersLogs[header.value].item_value"
                      :item-text="filtersLogs[header.value].item_text"
                      :placeholder="filtersLogs[header.value].placeholder"
                      class="purple-input"
                      :search-input.sync='searchAutocomplete[header.value]'
                    ></v-autocomplete>

                    <v-menu
                      v-if="filtersLogs[header.value].type == 'date'"
                      v-model="filtersLogs[header.value].datePicker"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                      min-width="290px"
                    >
                      <template slot="activator">
                        <v-text-field
                          clearable
                          v-model="filtersLogs[header.value].value"
                          :label="filtersLogs[header.value].placeholder"
                          readonly
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        dark
                        v-model="filtersLogs[header.value].value"
                        no-title
                        @input="filtersLogs[header.value].datePicker = false"
                      ></v-date-picker>
                    </v-menu>

                  </div>
                </th>
              </tr>
            </template>


            <template slot="items" slot-scope="{ item }">
              <tr>
                <!-- issue 659 -->
                <td v-for="(header,headeridx) in headersLogs" :class="{ 'text-xs-right': header.value === 'actions' }" v-bind:key="headeridx">
                  <template v-if='header.value === "details"'>
                    <safety-log-details :item="item" />
                  </template> 
                  <!-- //issue 679 -->
                  <v-tooltip top v-else-if="header.value === 'actions' && item.request.type !== 'raw_log'">
                  <!-- //issue 679 -->
                    <template slot="activator" slot-scope="{ on }" v-if="item.entity && item.entity_id">
                      <a flat @click="openAuditTrail(item)" class="ml-2">
                        <v-icon v-on="on" color="primary">mdi-timeline-clock-outline</v-icon>
                      </a>
                    </template>
                    <span>Audit Trail</span>
                  </v-tooltip>
                  <template v-else>
                    {{header.render ? header.render(item) : item[header.value]}}
                  </template>
                <!-- issue 659 -->
                </td>
              </tr>

            </template>
           
          </v-data-table>
        </material-card>
      </v-flex>


      <input
        id="file"
        ref="file"
        type="file"
        style="display: none"
        accept=".xls, .xlsx"
        @change="handleFileUpload()"
      />

      <v-dialog v-model="auditTrail.open" width="1200px">
        <safety-audittrail-timeline v-if='auditTrail.open' :entity="auditTrail.entity" :entity_id='auditTrail.entityId' />
      </v-dialog>

    </v-layout>
  </v-container>
</template>

<script>
import XLSX from "xlsx";
import { getList as getLogList, getDashboardData } from "@/api/log";
import { getList as getAdverseEventsList, importMultipleSae } from "@/api/adverse_event";
import { getList as getAccountList } from "@/api/account";
import { getList as getProtocolList } from '@/api/protocol'
// import { getLogRouteList } from "@/api/log";
import { get } from "@/api/base_api";
import { normalizeFilters } from "@/utils/filters";
//issue 257 services
import moment from 'moment';
//issue 257 services
export default {
  data() {
    return {
      protocolAdverseEventSelected:null,
      protocolListAdverseEvents:[],
      loadingLogs: false,
      loading: false,
      logs: [],
      adverse_events: [],
      medical_monitor_adverse_events: [],
      medical_monitor_notified: [],
      medical_monitor_query_adverse_events: [],
      totalLogs: 0,
      totalAdverseEvents: 0,
      totalMedicalMonitorAdverseEvents: 0,
      totalMedicalMonitorNotified: 0,
      totalMedicalMonitorQueryAdverseEvents: 0,
      searchAccount: '',
      dashboardData: {
        adverse_event: '-',
        pregnancy: '-',
        spm: '-',
      },
      paginationLogs: {
        rowsPerPage: 5,
        page: 1,
        sortBy: "insert_at",
        descending: true,
      },
      auditTrail: {
        open: false,
        entityId: null
      },      
      paginationAdverseEvents: {
        rowsPerPage: 2,
        page: 1,
        sortBy: "insert_at",
        descending: true,
      },

      paginationMedicalMonitor: {
        rowsPerPage: 2,
        page: 1,
        sortBy: "insert_at",
        descending: true,
      },
      paginationMedicalMonitorNotified: {
        rowsPerPage: 2,
        page: 1,
        sortBy: "insert_at",
        descending: true,
      },
      paginationMedicalMonitorQuery: {
        rowsPerPage: 2,
        page: 1,
        sortBy: "insert_at",
        descending: true,
      },

      searchAutocomplete: {
        'account_id':''
      },
      filtersLogs: {
        'insert_at' : {
          type:'date',
          value: undefined,
          placeholder: 'Choose Date',
          replace: 'VALUE%',
        },
        'account_id': {
          type:'autocomplete',
          value: undefined,
          replace: 'VALUE',
          placeholder: 'Search',
          item_value:'id',
          item_text: 'email',
          list: [],
        },
        'protocol_id': {
          type:'autocomplete',
          value: undefined,
          replace: 'VALUE',
          placeholder: 'Search',
          item_value:'id',
          item_text: 'name',
          list: [],
        },        
        'action' : {
          type:'text',
          value: undefined,
          placeholder: 'Choose Action',
          replace: '%VALUE%',
        },        
        'section' : {
          type:'text',
          value: undefined,
          placeholder: 'Choose Section',
          replace: '%VALUE%',
        },
      },
      headersLogs: [
        {
          sortable: false,
          text: "Insert at",
          value: "insert_at",
          //issue 257 services
          render: item => moment(new Date(item.insert_at)).format('DD-MMM-YYYY HH:mm:ss')
          //render: item => new Date(item.insert_at).toLocaleString()
          //issue 257 services
        },
        {
          sortable: false,
          text: "Account",
          value: "account_id",
          render: (el) => {
            return  el.account.email + ' (' + el.account.name + (el.account.surname ? ' ' + el.account.surname : '') + ')'; 
          } 
        },
        {
          text: 'Protocol',
          value: 'protocol_id',
          render: item => {
            //issue 659
            var p = null
            try {
              p = this.findValues(item, 'protocol');
            } catch (error) {
            }
            var pname = ''
            if (p && p.length && p.length > 0)
            {

              for (let index = 0; index < p.length; index++) {
                const pp = p[index];
                if (pp && pp.name)
                {
                  pname = pp.name
                  break          
                }
              }
            }
            return pname
            /*
            if(item && item.response && item.response.data && item.response.data.protocol && item.response.data.protocol.name)
            {
              return item.response.data.protocol.name
            }
            else if (item && item.response && item.response.error_details && item.response.error_details.protocol && item.response.error_details.protocol.name)
            {
              return item.response.error_details.protocol.name
            }
            else if (item && item.request && item.request.protocol && item.request.protocol.name)
            {
              return item.request.protocol.name
            }
            else if (item && item.protocol && item.protocol.name)
            {
              return item.protocol.name
            }
            else
            {
              return item
            }
            */
            /*
            const protocol = 
              (item && item.response && item.response.data && item.response.data.protocol) 
              ||
              (item && item.request && item.request.protocol) 
              ||
              (item && item.protocol);
              if (protocol) {
                return protocol.name || protocol
              }
            */
            //issue 659
          },
        },
        {
          text: 'Action',
          value: 'action',
          sortable: false,
          render: item => {
            return item.action.replace("Update Pdf Filename","Update Pdf") //issue 657
          },
        },
        {
          text: 'Section',
          value: 'section',
        },
        {
          text: 'Details',
          value: 'details'
        },
        {
          text: 'Actions',
          value: 'actions',
          align: "right",
          //issue 679
          sortable: false,
          //issue 679
        }
      ],
      headersAdverseEvents: [
        { text: "Protocol", align: "left", value: "protocol_id", sortable: false ,search:true},
        { text: "Cin", value: "cin", sortable: false },
        { text: "Rec.Date", value: "receipt_date", sortable: false },
        { text: "Patient", value: "patient_id", sortable: false },
        { text: "Site", value: "site_id", sortable: false },
        { text: "Event", value: "event_reported", sortable: false },
        { text: "Type", value: "type", sortable: false },
        { text: "Triage", value: "validation_user_triage", sortable: false },
        { text: "Status", value: "status", sortable: false },
        { text: "Sent", value: "sent_to_companies", sortable: false },
        { text: "Actions", value: "actions", sortable: false, align: "center" }
      ]
    };
  },
  created() {
    this.$store.dispatch("app/loadSponsors");
    this.$store.dispatch("app/sponsorsDisabled", false);
  },
  computed: {
    filtersAdverseEvents() {
      return {
         'protocol.sponsor_id': {
            value: this.$store.getters.sponsor_id
          },
          isShowClosedProtocol:this.$store.getters.isShowClosedProtocol
      }
    },
    isMM() {
      return this.$store.getters.userObj.role == 'Medical Monitor'
    },
    isGuest() {
      return this.$store.getters.userObj.role == 'Guest'
    }
  },
  watch: {
     '$store.getters.protocols': {
      handler(newVal) {
        if (newVal && newVal.length) {
          this.getMedicalMonitorQueryAdverseEvent()
        }
      },
      deep: true,
      immediate: true
    },
    searchAutocomplete: {
      async handler(val, oldVal) {
        if (val['account_id']) {
          const data = await getAccountList({'email':'%'+val['account_id']+'%'})
          this.filtersLogs['account_id'].list = data.data
        }
        if (val['protocol_id']) {
          const data = await getProtocolList({'name':'%'+val['protocol_id']+'%'})
          
          this.filtersLogs['protocol_id'].list = data.data
        }
      },
      deep: true
    },
    searchAccount: {
      handler(val, oldVal) {
        console.log("Search account changed")
      },
      deep: false
    },
    paginationLogs: {
      handler(val, oldVal) {
        if (oldVal.totalItems){
          this.getLogs()
        }
      },
      deep: false
    },
    filtersLogs: {
      handler(val) {
        this.paginationLogs.page = 1
        this.getLogs()
      },
      deep: true
    },
    paginationAdverseEvents: {
      handler(val, oldVal) {
        if (oldVal.totalItems){
          this.getAdverseEvents()
        }
      },
      deep: false
    },
    paginationMedicalMonitor: {
      handler(val, oldVal) {
        if (oldVal.totalItems){
          this.getMedicalMonitorAdverseEvent()
        }
      },
      deep: false
    },
    paginationMedicalMonitorNotified: {
      handler(val, oldVal) {
        if (oldVal.totalItems){
          this.getMedicalMonitorNotified()
        }
      },
      deep: false
    },
    paginationMedicalMonitorQuery: {
      handler(val, oldVal) {
        if (oldVal.totalItems){
          this.getMedicalMonitorQueryAdverseEvent()
        }
      },
      deep: false
    },
    filtersAdverseEvents: {
      async handler(val) {
        this.paginationAdverseEvents.page = 1
        this.getAdverseEvents()
        this.getMedicalMonitorAdverseEvent()
        this.getMedicalMonitorNotified()
        this.getMedicalMonitorQueryAdverseEvent()
        this.getDashboardData()
        this.protocolAdverseEventSelected=null
        let protocolFilter={'protocol.sponsor_id':this.$store.getters.sponsor_id,"protocol.status": ['Open','Draft']}
        if(this.$store.getters.isShowClosedProtocol){
          protocolFilter={'protocol.sponsor_id':this.$store.getters.sponsor_id,"protocol.status": ['Open','Draft','Closed']}
        }      
        const data = await getProtocolList({protocolFilter},{rowsPerPage:-1, sortBy:'name'})
        this.protocolListAdverseEvents=data.data
      },
      deep: true
    }
  },
  async mounted() {
    this.getAdverseEvents()
    this.getMedicalMonitorAdverseEvent()
    this.getMedicalMonitorNotified()
    this.getLogs()
    this.getDashboardData()

    this.$root.$on('updateAdverseEvents', () => {
      this.getAdverseEvents()
      this.getDashboardData()
      this.getMedicalMonitorAdverseEvent()
      this.getMedicalMonitorNotified()
      this.getMedicalMonitorQueryAdverseEvent()
    });
    let protocolFilter={'protocol.sponsor_id':this.$store.getters.sponsor_id,"protocol.status": ['Open','Draft']}
        if(this.$store.getters.isShowClosedProtocol){
          protocolFilter={'protocol.sponsor_id':this.$store.getters.sponsor_id,"protocol.status": ['Open','Draft','Closed']}
        }
    const data = await getProtocolList({protocolFilter},{rowsPerPage:-1, sortBy:'name'})
    this.protocolListAdverseEvents=data.data
  },
  methods: {
    //issue 659
    findValues(obj, key){
      return this.findValuesHelper(obj, key, []);
    }
    ,
    findValuesHelper(obj, key, list) {
      if (!obj) return list;
      if (obj instanceof Array) {
        for (var i in obj) {
          var newlist  = this.findValuesHelper(obj[i], key, [])  
          for (let o = 0; o < newlist.length; o++) 
          {
            list.push(newlist[o])
          }
        }
        return list;
      }
      if (obj[key]) 
      {
        list.push(obj[key]);
      }
      if ((typeof obj == "object") && (obj !== null) ){
        var children = Object.keys(obj);
        if (children.length > 0){
          for (i = 0; i < children.length; i++ ){
              var newlist = this.findValuesHelper(obj[children[i]], key, [])
              for (let o = 0; o < newlist.length; o++) 
              {
                list.push(newlist[o])
              }
          }
        }
      }
      return list;
    }
    ,
    //issue 659
    //issue 257 services
    formatDate(x)
    {
      return moment(new Date(x)).format('DD-MMM-YYYY')
    }
    ,
    //issue 257 services
    filterChanged(protocol_id) {
      this.getAdverseEvents(protocol_id) 
    },
    openAuditTrail (item) {
      this.auditTrail.entity = item.entity
      this.auditTrail.entityId = item.entity_id
      this.auditTrail.open = true
    },    
    getLogs() {
      this.loading = true
      const filters = normalizeFilters(JSON.parse(JSON.stringify(this.filtersLogs)))
      //newlogs
      /*
      if (filters.protocol_id) {
        //filters.protocol_id = [{ response: `JSON(%${filters.protocol_id}%,$.data.protocol_id)` }, { request: `JSON(%${filters.protocol_id}%,$.protocol_id)` }]
        filters.protocol_id = [{ response: `JSON(%${filters.protocol_id}%,$.data.protocol_id)` }]
      }
      */
      //newlogs
      this.loadingLogs = true
      getLogList(filters, this.paginationLogs).then(data => {
        this.paginationLogs.rowsPerPage = data.perPage
        this.paginationLogs.page = data.currentPage
        this.paginationLogs.totalItems = this.totalLogs = data.tot
        data.data.forEach(function(el) { 
          el.expanded = false
        });
        this.logs = data.data.map((item)=>{
          if(["Spm","spm"].includes(item.section)){
            item.section="SPM"
          }

          //issue 363
          if(item.action === 'Removepdf')
          {
            item.action = "Remove PDF"
          }
          if(item.action === 'Uploadpdf')
          {
            item.action = "Upload PDF"
          }
          //issue 363

          //issue 745
          //per i pregressi
          /*
          if(item.section === 'Mm Query')
          {
            item.section = "MM Query"
          }
          if (item.request && item.request.adverse_event_id && item.request.adverse_event_id > 0)
          {
            if (item.action === 'Insert')
            {
              item.action = "Insert Adverse Event"
            }
          }
          */
          //per i pregressi
          //issue 745
          

          return item
        })
        this.loading = false
      }).finally(() => this.loadingLogs = false);
    },
    getAdverseEvents(protocol_id = null) {
      this.loading = true;
      const filters = normalizeFilters(JSON.parse(JSON.stringify(this.filtersAdverseEvents)));
      if(protocol_id){        
        filters['protocol.id']=protocol_id
      }
      filters['is_read'] = 0;
      
      
      getAdverseEventsList(filters, this.paginationAdverseEvents).then(data => {
        this.paginationAdverseEvents.rowsPerPage = data.perPage;
        this.paginationAdverseEvents.page = data.currentPage;
        this.paginationAdverseEvents.totalItems = this.totalAdverseEvents = data.tot;
        data.data.forEach(function(el) { 
           el.protocolName = el.protocol.name;
           el.siteName = el.site.name;
        });
        this.adverse_events = data.data;   
        this.loading = false;
      });
    },
    getMedicalMonitorAdverseEvent() {
      this.loading = true;
      const filters = normalizeFilters(JSON.parse(JSON.stringify(this.filtersAdverseEvents)));
      filters['mm_changed'] = 1;
      getAdverseEventsList(filters, this.paginationMedicalMonitor).then( data => {
        this.paginationMedicalMonitor.rowsPerPage = data.perPage;
        this.paginationMedicalMonitor.page = data.currentPage;
        this.paginationMedicalMonitor.totalItems = this.totalMedicalMonitorAdverseEvents = data.tot;
        data.data.forEach(function(el) { 
           el.protocolName = el.protocol.name;
           el.siteName = el.site.name;
        });
        this.medical_monitor_adverse_events = data.data;
        this.loading = false;
      })
    },
    getMedicalMonitorNotified() {
      this.loading = true;
      const filters = normalizeFilters(JSON.parse(JSON.stringify(this.filtersAdverseEvents)));
      filters['mm_notified'] = 1;
      getAdverseEventsList(filters, this.paginationMedicalMonitorNotified).then( data => {
        this.paginationMedicalMonitorNotified.rowsPerPage = data.perPage;
        this.paginationMedicalMonitorNotified.page = data.currentPage;
        this.paginationMedicalMonitorNotified.totalItems = this.totalMedicalMonitorNotified = data.tot;
        data.data.forEach(function(el) { 
           el.protocolName = el.protocol.name;
           el.siteName = el.site.name;
        });
        this.medical_monitor_notified = data.data;
        this.loading = false;
      })
    },
    getMedicalMonitorQueryAdverseEvent() {
      this.loading = true;
      const filters = normalizeFilters(JSON.parse(JSON.stringify(this.filtersAdverseEvents)));
      const protocolIdsArray = this.$store.getters.protocols.map(p => p.id)
      if (!protocolIdsArray.length) {
        return
      }
      const protocolIds = protocolIdsArray.join('_')
      get(`/mm_query_responded/${protocolIds}`, filters, this.paginationMedicalMonitorQuery).then( data => {
        this.paginationMedicalMonitorQuery.rowsPerPage = data.perPage;
        this.paginationMedicalMonitorQuery.page = data.currentPage;
        this.paginationMedicalMonitorQuery.totalItems = this.totalMedicalMonitorQueryAdverseEvents = data.tot;
        if(data.data){
            if(data.data.length){
              data.data.forEach(function(el) { 
              el.protocolName = el.protocol.name;
              el.siteName = el.site.name;
            });
          }
        }
        this.medical_monitor_query_adverse_events = data.data;
        this.loading = false;
      })
    },
    getDashboardData() {    
      getDashboardData({"protocol.sponsor_id":this.filtersAdverseEvents['protocol.sponsor_id']}).then(data => {
        this.dashboardData = data
      })
    },
    addAdverseEvent() {
      this.$store.dispatch(
        "app/openAdverseEventMandatoryDialog",
        {}
      );
    },
    upsertPage(item) {
      this.$store.commit('app/adverseEventItem', item);
      this.$router.push('/adverse_event/' + item.id);
    },
    pickFile() {
      this.$refs.file.click();
    },
    handleFileUpload(event) {

      const file = this.$refs.file.files[0];
      if (!file) {
        return;
      }
      this.$store.dispatch("app/startLoading");
      const reader = new FileReader();
      reader.onload = this.processSaeExcel;
      reader.readAsBinaryString(file);
    },
    processSaeExcel(e) {

      console.log("PROCESSO FILE : ", e)

      setTimeout(() => { // questo per rendere il blocco async
        const data = e.target.result;

        // Questa fottuta è bloccante
        const wb = XLSX.read(data, { type: "binary",  cellDates: true });
        const first_sheet = wb.SheetNames[0];

        // Override Date obj toJSON to format date (YYYY-MM-DD)
        Date.prototype.toJSON = function() {

            var month = '' + (this.getMonth() + 1),
            day = '' + this.getDate(),
            year = this.getFullYear();

            if (month.length < 2) {
              month = '0' + month;
            }

            if (day.length < 2) {
              day = '0' + day;
            }

            return [year, month, day].join('-');
        };

        // Check !ref 
        delete wb.Sheets[first_sheet]['!margins'];
        const ref = wb.Sheets[first_sheet]['!ref'];
        delete wb.Sheets[first_sheet]['!ref'];

        const refEl = ref.split(':');
        const refLatestRow = refEl[1].match(/(\d+)/)[0]; 
        const refLatestCol = refEl[1].replace(/[0-9]/g, '');

        const sheetKeys = Object.keys(wb.Sheets[first_sheet]);
        let maxRow = 0;

        sheetKeys.map( el => {
          if (el[0] == '!') {
            return;
          }
          try {
            var n = parseInt(el.match(/(\d+)/)[0]);
            maxRow = maxRow < n ? n : maxRow;
          } catch(e) {
            console.log(e, el)
          }
        });

        const newRef = refEl[0] + ':' + refLatestCol + maxRow;
       
        wb.Sheets[first_sheet]['!ref'] = ref;

        if ( newRef != ref) {
           const message = 'This excel appears to be corrupt, SafetyDB has fix it, please check the data integrity!';
           this.$store.dispatch("app/openSnackbar", {
              message,
              color: "error"
            });
          
          console.log('New !REF', newRef);
          wb.Sheets[first_sheet]['!ref'] = newRef;
        }

        if (sheetKeys.length > 2000000) {
          const message = "Spreadsheet is too long! Pleae verify the empty rows.";
          // this.$store.dispatch("app/openAlert", {message});
          this.$store.dispatch("app/openSnackbar", {
            message,
            color: "error"
          });
          this.$store.dispatch("app/stopLoading");
          return;
        }

        const rows = XLSX.utils.sheet_to_json(wb.Sheets[first_sheet], {
          header: 1,
          blankRows: false,
          defval: "",
        });

        if (!rows.length) {
          const message = "Spreadsheet is empty!";
          // this.$store.dispatch("app/openAlert", {message});
          this.$store.dispatch("app/openSnackbar", {
            message,
            color: "error"
          });
          this.$store.dispatch("app/stopLoading");
          return
        }

        importMultipleSae(rows).then( ret => {

          let message  =  ret.tot + " Adverse events elaborated successfully. \n"
          message +=  ret.updated + " Adverse events have been update successfully. \n"
          message +=  ret.errors + " Adverse events had an error during the update (view logs) ",

          this.$store.dispatch("app/openSnackbar", {
            message,
            color: ret.errors ? "error" : "success"
          });

        }) .catch( e => {
          this.$store.dispatch("app/openSnackbar", {
            message: "An Error occurred during the upload : " + e.response.error_messages,
            color: "error"
          });
        }).finally( () => {
           this.$store.dispatch("app/stopLoading");
        })

       
        this.$refs.file.value = '';
        
      }, 50);
    
      
      // this.loading = false;
      // this.$store.dispatch("app/stopLoading");
      //this.initDataset(rows);
    },
  },
  filters: {
    truncate: function (text, length, suffix) {
      if (text.length > length) {
          return text.substring(0, length) + suffix;
      }
      return text;
    },
  }
};
</script>

<style lang="scss">
.dataTable {
  .v-datatable__actions {
    color: black;
    .v-btn__content {
      color: black;
    }
    .v-btn {
      background-color: rgb(241, 241, 241);
    }
  }
 .read td {
    font-size: 14px;
    font-weight: 300;
  }
  .unread td{
    font-weight:bold;
    background:#ffffff;
  }
  tr.lighten-3 th {
      padding: 0px 5px 0px 5px;
  }
}
</style>